module.exports = __webpack_public_path__ + "img/_b_.dec580e1.svg";